import { useTranslation } from "react-i18next";
import { Tag } from "@carbon/react";
import { SupplierRfqActivity } from "../../types";
import { formatDateTime } from "../../utils/utils";
import SupplierValidationTag from "./SupplierValidationTag";

type SupplierViewStatusProps = {
  activity?: SupplierRfqActivity;
};

/**
 * What the buyer needs to know of an invited supplier: validated or not, quoted or not, and whether
 * they opened the RFQ ("Entró" with the first and last visit and how many visits, or "No entró
 * todavía"). Nothing is shown while the activity has not loaded.
 */
const SupplierViewStatus = ({ activity }: SupplierViewStatusProps) => {
  const { t } = useTranslation();
  if (!activity) return null;

  const { firstViewedAt, lastViewedAt, viewCount, quotedAt } = activity;
  const statusTags = (
    <>
      <SupplierValidationTag activity={activity} />
      <Tag type={quotedAt ? "blue" : "outline"} size="sm">
        {t(
          quotedAt
            ? "tenders.supplierActivity.quoted"
            : "tenders.supplierActivity.notQuoted"
        )}
      </Tag>
    </>
  );

  if (!firstViewedAt || !lastViewedAt) {
    return (
      <div className="bid-suppliers__activity">
        {statusTags}
        <Tag type="outline" size="sm">
          {t("tenders.supplierActivity.notViewed")}
        </Tag>
      </div>
    );
  }

  return (
    <div className="bid-suppliers__activity">
      {statusTags}
      <Tag type="purple" size="sm">
        {t("tenders.supplierActivity.viewed")}
      </Tag>
      <span className="bid-suppliers__activity-detail">
        {t("tenders.supplierActivity.viewedDetail", {
          first: formatDateTime(firstViewedAt),
          last: formatDateTime(lastViewedAt),
          count: viewCount,
        })}
      </span>
    </div>
  );
};

export default SupplierViewStatus;
